<div class="row">
    <div class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!showType" class="text-center">

            <div class="mb-3">
                <img style="width:86px;height:auto" src="/assets/logo.png" class="img">
            </div>

            <div class="mb-1 fs-4 fw-bold">
                STROOP Test
            </div>

            <div class="text-muted" style="white-space: pre-wrap;">
                {{data.info}}
            </div>

            <div class="btn-group">
                <div class="btn-item">
                    <button (click)="showType='congruent';getData('STROOP-congruent');" class="btn flex-column gap-3">
                        <div class="d-flex align-items-center justify-content-center bg-pink function">
                            <i class="material-icons">task_alt</i>
                        </div>
                        <div class="fw-bold">
                            Congruent
                        </div>
                        <div class="border arrow d-flex align-items-center justify-content-center rounded-circle">
                            <i class="material-icons icon-pink">
                                arrow_forward
                            </i>
                        </div>
                    </button>
                </div>
                <div class="btn-item">
                    <button (click)="showType='incongruent';getData('STROOP-Incongruent');" class="btn flex-column gap-3">
                        <div class="d-flex align-items-center justify-content-center bg-yellow function">
                            <i class="material-icons">compare_arrows</i>
                        </div>
                        <div class="fw-bold">
                            Incongruent
                        </div>
                        <div class="border arrow d-flex align-items-center justify-content-center rounded-circle">
                            <i class="material-icons icon-yellow">
                                arrow_forward
                            </i>
                        </div>
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="showType" class="d-flex position-relative text-center flex-column justify-content-center">
            <div class="mb-3">
                <img style="width:86px;height:auto" src="/assets/logo.png" class="img">
            </div>
            <div class="mb-1">
                <div [ngSwitch]="showType" class="fs-4 fw-bold">
                    <span *ngSwitchCase="'congruent'">Congruent</span>
                    <span *ngSwitchCase="'incongruent'">Incongruent</span>
                </div>
            </div>
            <div class="text-muted" style="white-space: pre-wrap;">
                {{data.info}}
            </div>
            <div class="pt-5 px-md-5">
                <a [class.disabled]="isStarted!=1" class="btn btn-start w-100" routerLink="{{showType}}">
                    {{isStarted!=1?'Test hasn\'t started yet':'Start'}}
                </a>
            </div>
        </div>

        <div class="mt-4 d-flex mb-2" [class.px-md-5]="showType">
            <div class="card bg-light rounded-4 w-100">
                <div class="card-body p-1">
                    <div class="disclaimer">
                        <div class="d-flex align-items-center px-1">
                            <div class="pe-3">
                                <img src="/assets/disclaimer.svg">
                            </div>
                            <div>
                                <div class="fw-bold">Disclaimer</div>
                                <div class="text-muted font-book">
                                    This trial are demo for Stroop Test
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
